export default __webpack_public_path__ + "static/media/jasperactive-ac-icon.0aa2fc7c.svg";